import styles from "../../profile/profile.module.css";
import { useState, useRef } from "react";
import { MdAddCircleOutline } from "react-icons/md";
import { MdRemoveCircleOutline } from "react-icons/md";
import axios from "axios";
import { connection } from "utils/apiConnection.ts";
import toast, { Toaster } from "react-hot-toast";
const LoginTatclub = ({ updater, setUpdater }) => {
  const [SelectedUserInformation, setSelectedUserInformation] = useState({
    num: "",
    num2: "",
    title: "",
    urlPage: "",
    about: "",
    tags: [],
    address: "",
    cover: null,
    logoShop: null,
    coverId: 0,
    logoShopId: 0,
    socialMedia: [
      { nameField: "", selectField: "-1" },
      { nameField: "", selectField: "-1" },
    ],
  });

  let x = {
    socialMedia: [
      { nameField: "", selectField: "-1" },
      { nameField: "", selectField: "-1" },
    ],
  };

  const inputRef = useRef();

  async function changeHandlerImg(e) {
    setSelectedUserInformation({
      ...SelectedUserInformation,
      [e.target.name]: e.target.files[0],
    });
    let result = await connection("uploadfiles", {
      "files[]": e.target.files[0],
    });
    setSelectedUserInformation((prev) => {
      return { ...prev, [e.target.name + "Id"]: result.result[0].id };
    });
  }
  const changeHandlerLogo = (e) => {
    let myFormData = new FormData();
    myFormData.append("files[]", SelectedUserInformation.logoShop);
    axios
      .post("http://tatclub.tatdemo.ir/api/uploadfiles", myFormData)
      .then((res) => {
        console.log(res);
        setSelectedUserInformation({
          ...SelectedUserInformation,
          [e.target.name]: e.target.files[0],
        });
      })
      .catch((err) => console.log(err));
  };

  const handleChangeInput = (index, event) => {
    const values = [...SelectedUserInformation.socialMedia];
    values[index][event.target.name] = event.target.value;
    setSelectedUserInformation({
      ...SelectedUserInformation,
      socialMedia: values,
    });
  };
  const handleAddFields = () => {
    setSelectedUserInformation((pervState) => {
      pervState.socialMedia = [
        ...pervState.socialMedia,
        { nameField: "", selectField: "-1" },
      ];
      return { ...pervState };
    });
  };
  const handleRemoveFields = (index) => {
    const values = [...SelectedUserInformation.socialMedia];
    values.splice(index, 1);

    setSelectedUserInformation({
      ...SelectedUserInformation,
      socialMedia: values,
    });
  };

  async function postHandler() {
    let x = { socialMedia: SelectedUserInformation.socialMedia };
    let coverx = SelectedUserInformation.coverId;
    let logox = SelectedUserInformation.logoShopId;
    if (
      SelectedUserInformation.urlPage === "" ||
      SelectedUserInformation.title === ""
    ) {
      toast.error("نام و آدرس صفحه فروشگاه را وارد نمایید");
      return null;
    }

    if (SelectedUserInformation.coverId === undefined) coverx = "";

    if (SelectedUserInformation.logoShopId === undefined) logox = "";

    let result = await connection("addshop", {
      tell: SelectedUserInformation.num2,
      mobile: SelectedUserInformation.num,
      title: SelectedUserInformation.title,
      shopSuffix: SelectedUserInformation.urlPage,
      aboutUs: SelectedUserInformation.about,
      addressText: SelectedUserInformation.address,
      coverImgId: coverx,
      logoImgId: logox,
      otherParams: JSON.stringify(x),
    });
    setSelectedUserInformation({
      num: "",
      num2: "",
      title: " ",
      urlPage: "",
      about: "",
      tags: [],
      address: "",
      cover: null,
      logoShop: null,
      socialMedia: [
        { nameField: "", selectField: "-1" },
        { nameField: "", selectField: "-1" },
      ],
    });
    console.log("result.res", result.status);
    if (result.status == -1) {
      toast.error("آدرس صفحه وجود دارد");
    } else {
      toast.success("فروشگاه با موفقیت اضافه شد");
    }
    setUpdater(!updater);
  }

  // const postHandler = () => {
  //   let myFormData = new FormData();
  //   myFormData.append("title", SelectedUserInformation.title);
  //   myFormData.append("mobile", SelectedUserInformation.num);
  //   myFormData.append("tell", SelectedUserInformation.num2);
  //   myFormData.append("addressText", SelectedUserInformation.address);
  //   myFormData.append("shopSuffix", SelectedUserInformation.urlPage);
  //   myFormData.append("logoImgId", SelectedUserInformation.logoShopId);
  //   myFormData.append("aboutUs", SelectedUserInformation.about);
  //   myFormData.append("coverImgId", SelectedUserInformation.coverId);
  //   let x = { socialMedia: SelectedUserInformation.socialMedia };
  //   myFormData.append("otherParams", JSON.stringify(x));
  //   axios
  //     .post("http://tatclub.tatdemo.ir/api/addshop", myFormData)
  //     .then((res) => {
  //       console.log("data add", res.data.result);
  //       console.log("result", SelectedUserInformation.logoShopId);
  //       setSelectedUserInformation({
  //         num: "",
  //         num2: "",
  //         title: " ",
  //         urlPage: "",
  //         about: "",
  //         tags: [],
  //         address: "",
  //         cover: null,
  //         logoShop: null,
  //         socialMedia: [
  //           { nameField: "", selectField: "-1" },
  //           { nameField: "", selectField: "-1" },
  //         ],
  //       });
  //       setUpdater(!updater);
  //     })
  //     .catch((err) => console.log(err));
  // };
  return (
    <>
      <div
        class="modal fade text-dark"
        id={`exampleModal3`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                اشتراک تات کلاب{" "}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body" style={{ background: "#f2f0f1" }}>
              <div className="row">
                <div className={` col-lg-12     text-center  ${styles.cardPI}`}>
                  <div className={styles.flexbless2}>
                    <p className={styles.ppStyle}>عنوان فروشگاه</p>
                    <input
                      className={styles.inpu2}
                      type="text"
                      value={SelectedUserInformation.title}
                      onChange={(e) =>
                        setSelectedUserInformation({
                          ...SelectedUserInformation,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="title"
                    />
                  </div>
                </div>

                <div className={` col-lg-12     text-center  ${styles.cardPI}`}>
                  <div className={styles.flexbless2}>
                    <p className={styles.ppStyle}>آدرس صفحه</p>
                    <div class={`input-group  ${styles.inpu2} `} dir="ltr">
                      <div
                        class="input-group-prepend bg-white"
                        style={{ borderRadius: "20px" }}
                      >
                        <span
                          class="input-group-text"
                          id="basic-addon3"
                          style={{
                            borderRadius: "10px 0px 0px 10px",
                            height: "70px",
                            borderRight: "0",
                          }}
                        >
                          https://tatclub.com/
                        </span>
                      </div>
                      <input
                        style={{
                          borderRadius: "0 10px 10px 0",
                        }}
                        type="text"
                        className={`form-control ${styles.inurl}`}
                        id="basic-url"
                        aria-describedby="basic-addon3"
                        value={SelectedUserInformation.urlPage}
                        onChange={(e) =>
                          setSelectedUserInformation({
                            ...SelectedUserInformation,
                            [e.target.name]: e.target.value,
                          })
                        }
                        name="urlPage"
                      />
                    </div>
                  </div>
                </div>
                <div className={` col-lg-12    text-center  ${styles.cardPI}`}>
                  <div className={styles.flexbless2}>
                    <p className={styles.ppStyle}>اطلاعات تماس </p>
                    <div
                      className={`d-flex flex-column justify-content-between ${styles.wi22}`}
                      style={{ height: "70px" }}
                    >
                      <input
                        className={styles.nimInput}
                        type="text"
                        value={SelectedUserInformation.num}
                        onChange={(e) =>
                          setSelectedUserInformation({
                            ...SelectedUserInformation,
                            [e.target.name]: e.target.value,
                          })
                        }
                        name="num"
                      />
                      <input
                        className={styles.nimInput}
                        type="text"
                        value={SelectedUserInformation.num2}
                        onChange={(e) =>
                          setSelectedUserInformation({
                            ...SelectedUserInformation,
                            [e.target.name]: e.target.value,
                          })
                        }
                        name="num2"
                      />
                    </div>
                  </div>
                </div>
                <div className={` col-lg-12     text-center  ${styles.cardPI}`}>
                  <div className={styles.flexbless2}>
                    <p className={styles.ppStyle}>آدرس </p>
                    <input
                      className={styles.inpu2}
                      type="text"
                      value={SelectedUserInformation.address}
                      onChange={(e) =>
                        setSelectedUserInformation({
                          ...SelectedUserInformation,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="address"
                    />
                  </div>
                </div>
                <div
                  className={` col-lg-12     text-center 
                       ${styles.cardPI}`}
                >
                  <div className={styles.flexbless2}>
                    <p className={styles.ppStyle}> درباره ما</p>
                    <input
                      className={styles.inpu2}
                      type="text"
                      value={SelectedUserInformation.about}
                      onChange={(e) =>
                        setSelectedUserInformation({
                          ...SelectedUserInformation,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="about"
                    />
                  </div>
                </div>

                <div className={` col-lg-12     text-center  ${styles.cardPI}`}>
                  <div className={styles.flexbless2}>
                    <p className={styles.ppStyle}> کاور فروشگاه</p>
                    <input
                      type="file"
                      ref={inputRef}
                      onChange={changeHandlerImg}
                      className={`form-control input-color ${styles.inputt2} `}
                      id="profile-pic"
                      name="cover"
                      style={{ lineHeight: "4.5rem", padding: "0 10px" }}
                    />
                  </div>
                </div>
                <div className={` col-lg-12     text-center  ${styles.cardPI}`}>
                  <div className={styles.flexbless2}>
                    <p className={styles.ppStyle}> لوگو فروشگاه</p>
                    <input
                      type="file"
                      ref={inputRef}
                      onChange={changeHandlerImg}
                      className={`form-control input-color ${styles.inputt2} `}
                      name="logoShop"
                      style={{ lineHeight: "4.5rem", padding: "0 10px" }}
                    />
                  </div>
                </div>
                <div className={` col-lg-12     text-center  ${styles.cardPI}`}>
                  <p className={styles.ppStyle}>شبکه های اجتماعی</p>
                  {SelectedUserInformation.socialMedia.map(
                    (socialMedia, index) => (
                      <div
                        key={index}
                        className="d-flex w-100 flex-column justify-content-between  mt-2"
                      >
                        <div className="w-100 d-flex ">
                          <input
                            className={`w-100 text-end rounded ${styles.nimInput}`}
                            value={socialMedia.nameField}
                            onChange={(event) =>
                              handleChangeInput(index, event)
                            }
                            name="nameField"
                          />

                          <select
                            className={`form-select form-select-sm inputBoxSelect bg-light text-center ${styles.nimInput5}`}
                            aria-label="Default select example"
                            value={socialMedia.selectField}
                            onChange={(event) =>
                              handleChangeInput(index, event)
                            }
                            name="selectField"
                          >
                            <option selected hidden disabled value="-1">
                              انتخاب کنید{" "}
                            </option>
                            <option value="1">instagram </option>
                            <option value="2"> telegram</option>
                            <option value="3"> whatsApp</option>
                            <option value="4"> twitter</option>
                          </select>
                          <div
                            className="d-flex justify-content-evenly align-items-center "
                            style={{
                              width: "100px",
                              fontSize: "20px",
                              color: "#333",
                              cursor: "pointer",
                            }}
                          >
                            <MdAddCircleOutline onClick={handleAddFields} />
                            {index != 0 && (
                              <MdRemoveCircleOutline
                                onClick={() => handleRemoveFields(index)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
                {/* <div
                      className={` col-lg-12    text-center  ${styles.cardPI}`}
                    >
                      <div className={styles.flexbless2}>
                        <p className={styles.ppStyle}>برچسب ها</p>
                        <CreatableSelect
                          is
                          className={styles.inpuSlect}
                          value={value}
                          onChange={changeHandlerDaste}
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          ixsulti
                          options={optionDasteBandi}
                        />
                      </div>
                    </div> */}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => postHandler(SelectedUserInformation)}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginTatclub;
